// components/onboarding/StepViews.jsx
import { GraduationCap, Briefcase, Telescope, Info, User as UserIcon } from 'lucide-react';
import CollegeSearchInput from './CollegeSearchInput';

export const RoleSelection = ({ formData, setFormData }) => (
  <div className="w-full flex flex-col items-center text-center space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
    <div className="flex flex-col items-center space-y-4">
      <div className="relative">
        {formData.profileImage ? (
          <img src={formData.profileImage} alt="Profile" className="w-24 h-24 rounded-full border-4 border-white shadow-xl object-cover" />
        ) : (
          <div className="w-24 h-24 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 border-4 border-white shadow-xl">
            <UserIcon size={40} />
          </div>
        )}
        <div className="absolute -bottom-1 -right-1 bg-green-500 w-6 h-6 rounded-full border-4 border-white"></div>
      </div>
      <h2 className="text-2xl font-black text-gray-900 leading-tight">
        Welcome to CampusIRA, <br/>{formData.fullName.split(' ')[0]}!
      </h2>
    </div>

    <div className="w-full max-w-sm space-y-4 text-left">
      {[
        { id: 'student', title: 'Student / Intern', icon: <GraduationCap size={20}/>, desc: 'Unlock senior interview paths & campus feeds.' },
        { id: 'professional', title: 'Professional', icon: <Briefcase size={20}/>, desc: 'Share roadmaps or hire from your community.' },
        { id: 'explorer', title: 'Explorer', icon: <Telescope size={20}/>, desc: 'Browse public trends across colleges.' }
      ].map((item) => (
        <button 
          key={item.id}
          onClick={() => setFormData({ ...formData, role: item.id })}
          className={`p-4 border-2 rounded-2xl text-left transition-all w-full flex items-start space-x-4 ${
            formData.role === item.id ? 'border-blue-600 bg-blue-50/50' : 'border-gray-100 hover:border-blue-100'
          }`}
        >
          <div className={`p-3 rounded-xl ${formData.role === item.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-400'}`}>
            {item.icon}
          </div>
          <div>
            <h3 className="font-bold text-gray-800 text-sm">{item.title}</h3>
            <p className="text-[11px] text-gray-500 leading-tight">{item.desc}</p>
          </div>
        </button>
      ))}
    </div>
  </div>
);

export const AcademicInfo = ({ formData, setFormData }) => (
  <div className="w-full max-w-xl space-y-8 animate-in fade-in slide-in-from-right-4 duration-500">
    <div className="flex items-start space-x-4 bg-blue-50/80 p-5 rounded-2xl border border-blue-100 text-left">
      <Info className="text-blue-600 shrink-0" size={20} />
      <p className="text-xs text-blue-900 leading-relaxed">
        <strong>Why add your college?</strong> It unlocks the <b>"My Campus"</b> dashboard for exclusive interview questions from your seniors.
      </p>
    </div>
    <div className="space-y-6 text-left">
      <CollegeSearchInput formData={formData} setFormData={setFormData} />
      <div className="grid grid-cols-2 gap-4">
        <input type="text" placeholder="Branch (e.g. CSE)" value={formData.branch} className="w-full p-4 bg-gray-50 border-none rounded-xl text-sm" 
               onChange={(e) => setFormData({...formData, branch: e.target.value})}/>
        <input type="text" placeholder="Grad Year (e.g. 2026)" value={formData.graduationYear} className="w-full p-4 bg-gray-50 border-none rounded-xl text-sm"
               onChange={(e) => setFormData({...formData, graduationYear: e.target.value})}/>
      </div>
    </div>
  </div>
);